import React, {useState, useEffect} from 'react'
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap'
import CloseButton from 'react-bootstrap/CloseButton';
function NewService({serviceData, branches, removeService}) {
    const [formData, setFormData] = useState({
        serviceName : serviceData.name,
        serviceGroup : serviceData.group,
        baseServiceId : serviceData.id
    });
  return (
    <>
        <Card className='mb-3 new-service'>
            <Card.Header className='d-flex justify-content-between align-items-center'>
                <h5 className="card-title">{formData.serviceName}</h5>
                <CloseButton 
                    onClick={(e)=>removeService(e,formData.baseServiceId)}
                />
            </Card.Header>
            <Card.Body>
                <Form>
                    <input type='hidden' name='baseServiceId' value={formData.baseServiceId}/>
                    <Row>
                        <Col>
                            <Form.Group className='mb-3'>
                                <Form.Label>Service Name</Form.Label>
                                <Form.Control
                                className='service-name'
                                name='serviceName'
                                value={formData.serviceName}
                                readOnly
                            />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className='mb-3'>
                                <Form.Label>Group</Form.Label>
                                <Form.Select
                                    name='serviceGroup'
                                    value={formData.serviceGroup}
                                    readOnly
                                >
                                    <option>Select Group</option>
                                    <option value='IP Consultation'>IP Consultation</option>
                                    <option value='Biochemistry'>Biochemistry</option>
                                    <option value='Diagnosis'>Diagnosis</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className='mb-3'>
                                <Form.Label>Service Type</Form.Label>
                                <Form.Select
                                    name='serviceType'
                                    value={formData.type}
                                    readOnly
                                >
                                    <option>Select Type</option>
                                    <option value='IP Consultation'>Duration Based</option>
                                    <option value='Biochemistry'>Occurance Based</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <fieldset>
                        <legend>Branch specific rate</legend>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    branches.map(function(branch){
                                        return <tr key={branch.id}>
                                            <td>
                                                {branch.name}
                                            </td>
                                            <td>
                                                <Form.Group>
                                                    <Form.Control></Form.Control>
                                                </Form.Group>
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                    </fieldset>
                    <Button type='submit' className='my-3'>Save</Button>
                </Form>
            </Card.Body>
        </Card>
    </>
  )
}

export default NewService